import { get, IHttpRequestConfig, put } from "@/browser/http";
import { applyHeaders, extractDataFromResponse } from "@/core/api";
import { compose, IURLSearchParams } from "@/core/url";

import {
  assignmentsRevisionType,
  assignmentType,
  IAssignment,
  IAssignmentRevision,
  IPageableAssignment,
  pageableAssignmentType,
} from "./types-ensure";

const API = {
  list: "/api/assignments",
  get: "/api/assignments/{assignmentId}",
  contactPerson: "/api/assignments/{assignmentId}/contact-person/{consultantProfileId}",
  revisions: "/api/assignments/{assignmentId}/revisions",
};

export interface IFetchAssignmentsListParams extends IURLSearchParams {
  companyId?: number;
}

export function fetchAssignmentsList(params: IFetchAssignmentsListParams, options: IHttpRequestConfig = {}) {
  const { companyId, ...searchParams } = params;
  const url = compose(API.list, {}, searchParams);

  return get<IPageableAssignment>(url, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(pageableAssignmentType);
}

export interface IFetchAssignmentParams {
  assignmentId: number;
  companyId?: number;
}

export function fetchAssignment(params: IFetchAssignmentParams, options: IHttpRequestConfig = {}) {
  const { companyId, ...pathParams } = params;
  const url = compose(API.get, pathParams);

  return get<IAssignment>(url, applyHeaders({ companyId }, options)).then(extractDataFromResponse).then(assignmentType);
}

export interface IFetchAssignmentRevisionsListParams {
  assignmentId: number;
  companyId?: number;
}

export function fetchAssignmentRevisionsList(
  params: IFetchAssignmentRevisionsListParams,
  options: IHttpRequestConfig = {},
) {
  const { assignmentId, companyId } = params;
  const url = compose(API.revisions, { assignmentId });

  return get<IAssignmentRevision[]>(url, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(assignmentsRevisionType);
}

export interface IPutContactPersonParams {
  assignmentId: number;
  consultantProfileId: number;
  companyId?: number;
}

export const putContactPerson = (params: IPutContactPersonParams, data: object = {}, options?: IHttpRequestConfig) => {
  const { assignmentId, consultantProfileId, companyId } = params;
  const url = compose(API.contactPerson, { assignmentId, consultantProfileId });

  return put<void>(url, data, applyHeaders({ companyId }, options));
};
